import { InputSizes } from '@shared/ui/kit/input/model/types';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

type DropdownCheckIconProps = {
  size?: InputSizes;
};

const DropdownCheckIcon = (props: DropdownCheckIconProps) => {
  const { size = 'medium' } = props;
  return (
    <svg
      {...stylex.props(styles.base, styles[size])}
      style={{
        fill: colors.accentBackground,
      }}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7045 4.15347C17.034 4.4045 17.0976 4.87509 16.8466 5.20457L8.84657 15.7046C8.71541 15.8767 8.51627 15.9838 8.30033 15.9983C8.08439 16.0129 7.87271 15.9334 7.71967 15.7804L3.21967 11.2804C2.92678 10.9875 2.92678 10.5126 3.21967 10.2197C3.51256 9.92682 3.98744 9.92682 4.28033 10.2197L8.17351 14.1129L15.6534 4.29551C15.9045 3.96603 16.3751 3.90243 16.7045 4.15347Z"
        fill="#AE955F"
      />
    </svg>
  );
};

export default DropdownCheckIcon;
